import { render, staticRenderFns } from "./salesforce.vue?vue&type=template&id=b4661180"
import script from "./salesforce.vue?vue&type=script&lang=js"
export * from "./salesforce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports